/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getEmailNotifications } from "api/services/user";
import { userQueryKeys } from "./userQueryKeys";

export function useGetEmailNotifications(filters: any) {
  return useQuery({
    queryKey: userQueryKeys.emailNotifications(filters),
    queryFn: () => getEmailNotifications({ params: filters }).then((res) => res.data),
  });
}
